module.exports = __webpack_public_path__ + "static/media/litecoin-color.c619aada.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/litecoin-color.svg
// module id = 2389
// module chunks = 7